import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserGroup } from '../../../app/app.interfaces';


@Component({
  selector: 'user-group-drop-down',
  templateUrl: 'user-group-drop-down.html'
})

export class UserGroupDropDown {

  @Input() form: FormGroup;
  @Input() formKey: string;
  @Input() userGroups: UserGroup[];

  showGroupsDropdown: boolean = false;

  constructor(private changeDetector: ChangeDetectorRef) {

  }

  toggleGroupsDropdown(show: boolean = null){
    if(show!==null) this.showGroupsDropdown = show;
    else this.showGroupsDropdown=!this.showGroupsDropdown;

    this.changeDetector.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/partials/user-group/user-group-drop-down/user-group-drop-down.ts